module.exports = __webpack_public_path__ + "static/media/sub_menu_makeup.fc724126.png";